import LocalizedStrings from "react-localization";

export default new LocalizedStrings({
  hu: {
    welcome: "Üdvözöljük a BME Felhőben!",
    help: "Válassza ki az adatközpontot!",
    online: "ELÉRHETŐ",
    maintenance: "KARBANTARTÁS",
    unavailable: "NEM ELÉRHETŐ",
    contactUs: "Kapcsolat:",
    loading: "Betöltés...",
    caption: "VM-ek az utolsó 8 napban",
  },
  en: {
    welcome: "Welcome to BME Cloud!",
    help: "Choose your datacenter!",
    online: "ONLINE",
    maintenance: "MAINTENANCE",
    unavailable: "UNAVAILABLE",
    contactUs: "Contact:",
    loading: "Loading...",
    caption: "VMs in last 8 days",
  }
});



// WEBPACK FOOTER //
// ./src/strings.js